export const formatPrice = (price: number) => {
  return price ? `${Intl.NumberFormat('ru-RU').format(price)} ₽` : '';
};
